module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ServiceNotes"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', [_c('div', {
    staticClass: "md-form"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.notes),
      expression: "notes",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "md-textarea",
    attrs: {
      "type": "text",
      "id": "csp-notes"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "change": function($event) {
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.notes
    },
    attrs: {
      "for": "csp-notes"
    }
  }, [_vm._v("Notes")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-xs-12 card-title csp-card-title"
  }, [_vm._v("Any Notes for Us?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('p', {
    staticClass: "card-text csp-banner-text"
  }, [_vm._v("If you have any notes for us or our team or if you’d like us to reach out to you, please let us know below. Once you’re finished, just press “Submit” and that’s all you need to do!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1af44a5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/panels/ServiceNotes.vue
// module id = 852
// module chunks = 2